import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Privacy from '../views/Privacy.vue';
import Impressum from '../views/Impressum.vue';
import Disclaimer from '../views/Disclaimer.vue';
// import Covid from '../views/Covid.vue';
import appdata from '../appdata.json';

Vue.use(VueRouter);

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    props: { data: appdata }
  },
  // {
  //   path: '/covid',
  //   name: 'Covid',
  //   component: Covid,
  //   props: { data: appdata }
  // },
  {
    path: '/impressum',
    name: 'Impressum',
    component: Impressum,
    props: { data: appdata }
  },
  {
    path: '/disclaimer',
    name: 'Disclaimer',
    component: Disclaimer,
    props: { data: appdata }
  },
  // {
  //   path: '/privacy',
  //   name: 'Privacy',
  //   component: Privacy
  // }
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        selector: to.hash,
        // , offset: { x: 0, y: 10 }
      };
    } else {
      return { x: 0, y: 0 };
    }
  }
})

export default router
